var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHorizontalScrollDisabledRightIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3.73333,
    transform: "matrix(-1 0 0 1 36 0)",
    fill: "#F1F1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5328 25.4617C13.4581 25.5365 13.3988 25.6252 13.3583 25.7229C13.3178 25.8206 13.297 25.9253 13.297 26.031C13.297 26.1368 13.3178 26.2415 13.3583 26.3392C13.3988 26.4369 13.4581 26.5256 13.5328 26.6004C13.6076 26.6752 13.6964 26.7345 13.7941 26.775C13.8918 26.8154 13.9965 26.8362 14.1022 26.8362C14.2079 26.8362 14.3126 26.8154 14.4103 26.775C14.508 26.7345 14.5968 26.6752 14.6716 26.6004L22.7191 18.5529C22.7939 18.4782 22.8532 18.3894 22.8937 18.2917C22.9342 18.194 22.9551 18.0893 22.9551 17.9836C22.9551 17.8778 22.9342 17.7731 22.8937 17.6754C22.8532 17.5777 22.7939 17.4889 22.7191 17.4142L14.6716 9.3667C14.5206 9.21569 14.3158 9.13086 14.1022 9.13086C13.8887 9.13086 13.6838 9.21569 13.5328 9.3667C13.3818 9.5177 13.297 9.7225 13.297 9.93606C13.297 10.1496 13.3818 10.3544 13.5328 10.5054L21.012 17.9836L13.5328 25.4617Z",
    fill: "#979797"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHorizontalScrollDisabledRightIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HorizontalScrollDisabledRightIcon.92428422.svg";
export { ForwardRef as ReactComponent };